import { useEffect, useState } from 'react';
import { S } from '../../i18n/strings';

/**
 * Fotografía con marcador de posición.
 *
 * Una imagen que **falla al cargar** no es lo mismo que una ausente, pero en pantalla debe
 * verse igual: sin esto, el navegador dibuja el icono de imagen rota con el texto alternativo
 * encima, que es justo el "hueco" que el diseño evita en el caso de no tener foto. Cubre el
 * host caído, el usuario tras un proxy y la red que se corta a media descarga.
 */
export function Photo({
  src,
  alt,
  className,
  style,
  eager = false,
}: {
  src: string | null;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  eager?: boolean;
}) {
  const [failed, setFailed] = useState(false);

  // Al cambiar de foto (galería, otra tarjeta reciclada) se vuelve a intentar: el fallo era
  // de la imagen anterior, no de esta.
  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <div className={`photo-placeholder ${className ?? ''}`} style={style} role="img" aria-label={alt}>
        <span aria-hidden="true">🍽</span>
        <span className="photo-placeholder__text">{S.restaurantNoPhoto}</span>
      </div>
    );
  }

  return (
    <img
      className={className}
      style={style}
      src={src}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      onError={() => setFailed(true)}
    />
  );
}
